<script>
import { nextTick } from 'vue'
import QrcodeVue from 'qrcode.vue'

export default {
    name: 'QRCodesComponent',

    components: {
        QrcodeVue
    },

    props: {
        languageStrings: {
            type: Object,
            default: null
        }
    },

    emits: ['form-closed'],

    computed: {
        qrCodesArray() {
            return this.qrCodes.split('\n')
        }
    },

    data() {
        return {
            qrCodes: ""
        }
    },

    async mounted() {
        await nextTick()
        document.getElementById('form').focus()
    },

    methods: {
        // Helpers
        stopEnterPropagation() {
            // dummy to stop click propagation upwards in hierarchy            
        },

        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }
        },
        closeForm() {
            this.$emit('form-closed')
        },
        getQRCodeUrl(sif) {
            return 'https://' + window.location.host + '?sample=' + sif
        },
        printQRCodes() {
            if (this.qrCodes.length > 0) {
                // Get HTML to print from element
                const prtHtml = document.getElementById('print').innerHTML;

                // Open the print window
                const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

                WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <style type="text/css">
                        body > div { width: 100px; text-align: center; border: 1px solid black; padding: 5px; float: left; }
                    </style>
                </head>
                <body>
                    ${prtHtml}
                </body>
                </html>`);

                WinPrint.document.close();
                WinPrint.focus();
                WinPrint.print();
                WinPrint.close();
            }
        }
    }
}
</script>

<template>
    <div class="form">
        <div id="form" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu016 != null ? languageStrings.ui.menu016 : 'Generování QR kódů' }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="form-wrapper">
                <div class="form-content rows gap-10 qr-codes">
                    <div class="info">
                        {{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.qrcodes001 != null ? languageStrings.ui.qrcodes001 : 'Zadejte ALS kódy, pro které chcete vygenerovat QR kód. Na každém řádku musí být pouze jeden kód:' }}                        
                    </div>

                    <div class="qr-codes-input-output cols gap-10">
                        <textarea class="qr-codes-input" v-model="qrCodes" @keydown.stop="stopEnterPropagation" placeholder="123456"></textarea>
                        <div v-if="qrCodes.length > 0" id="print" class="qr-codes-output">
                            <div v-for="(line, i) in qrCodesArray" :key="i">
                                <qrcode-vue :value="getQRCodeUrl(line)" render-as="svg" />
                                <div>{{ line }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="edit-form-buttons">
                        <button class="button-small" @click="printQRCodes">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.qrcodes002 != null ? languageStrings.ui.qrcodes002 : 'Tisk' }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>